module.exports = __webpack_public_path__ + "static/media/info-circlePending.84e05adf.svg";